export enum InventoryStatus {
  Inactive = 0,
  Active = 1,
}

export const inventoryStatuses = [
  { label: $localize`Inactive`, value: InventoryStatus.Inactive },
  { label: $localize`Active`, value: InventoryStatus.Active },
]

export enum InventoryCondition {
  New = 'new',
  Good = 'good',
  Fair = 'fair',
  Excellent = 'excellent',
  Damaged = 'damaged',
  Worn = 'worn',
  Inoperable = 'inoperable',
  Depleted = 'depleted',
  Old = 'old',
}

export const inventoryConditions = [
  { label: $localize`New`, value: InventoryCondition.New },
  { label: $localize`Good`, value: InventoryCondition.Good },
  { label: $localize`Fair`, value: InventoryCondition.Fair },
  { label: $localize`Excellent`, value: InventoryCondition.Excellent },
  { label: $localize`Damaged`, value: InventoryCondition.Damaged },
  { label: $localize`Worn`, value: InventoryCondition.Worn },
  { label: $localize`Inoperable`, value: InventoryCondition.Inoperable },
  { label: $localize`Depleted`, value: InventoryCondition.Depleted },
  { label: $localize`Old`, value: InventoryCondition.Old },
]

export enum InventoryCategory {
  Furniture = 'furniture',
  Appliance = 'appliance',
  Electronics = 'electronics',
  Kitchenware = 'kitchenware',
  Bedding = 'bedding',
  Supplies = 'supplies',
  Consumables = 'consumables',
  Plants = 'plants',
  Decor = 'decor',
  Outdoor = 'outdoor',
  Pool = 'pool',
  Other = 'other',
}

export const inventoryCategories = [
  { label: $localize`Furniture`, value: InventoryCategory.Furniture },
  { label: $localize`Appliance`, value: InventoryCategory.Appliance },
  { label: $localize`Electronics`, value: InventoryCategory.Electronics },
  { label: $localize`Kitchenware`, value: InventoryCategory.Kitchenware },
  { label: $localize`Bedding`, value: InventoryCategory.Bedding },
  { label: $localize`Supplies`, value: InventoryCategory.Supplies },
  { label: $localize`Consumables`, value: InventoryCategory.Consumables },
  { label: $localize`Plants`, value: InventoryCategory.Plants },
  { label: $localize`Decor`, value: InventoryCategory.Decor },
  { label: $localize`Outdoor`, value: InventoryCategory.Outdoor },
  { label: $localize`Pool`, value: InventoryCategory.Pool },
  { label: $localize`Other`, value: InventoryCategory.Other },
]

export interface InventoryResponse {
  pkey: string
  account: number
  title: string
  description?: string
  category: InventoryCategory
  sub_category?: string
  condition: InventoryCondition

  images?: string[]
  files?: string[]
  rental_id?: string
  status?: InventoryStatus
  quantity?: number
  comments?: string
  replenish_count?: number
  replenished_at?: number
  supplier?: string
  replace_by?: string
  updated_at?: number
  purchase_price?: number
  purchased_at?: number
  attributes?: string[]

  created: number
  archived: number
}

export interface InventoryView extends InventoryResponse {
  createdView: string
  rentalView: string
  statusView: string
}

export interface SearchInventoryParams {
  rentals: string[]
  status: InventoryStatus
  categories: string[]
  conditions: InventoryCondition
  period: {
    from: number
    to: number
  }
}

export interface CreateInventoryPayload {
  account: number
  title: string
  description?: string
  category: InventoryCategory
  sub_category?: string
  condition: InventoryCondition

  images?: string[]
  files?: string[]
  rental_id?: string
  status?: InventoryStatus
  quantity?: number
  replenish_count?: number
  purchase_price?: number
  purchased_at?: number

  archived?: 0 | 1
}

export type UpdateInventoryPayload = Partial<CreateInventoryPayload>
